import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Music2, PlayCircle, ListMusic, Database } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";

interface TopSong {
  id: string;
  title: string;
  artist: string;
  plays: number;
}

interface MusicStatsCardProps {
  stats: {
    totalSongs: number;
    activePlaylists: number;
    storageUsed: string;
    topSongs: TopSong[];
  };
  className?: string;
}

export function MusicStatsCard({ stats, className }: MusicStatsCardProps) {
  const metrics = [
    {
      name: 'Toplam Şarkı',
      value: stats.totalSongs,
      icon: Music2,
      description: 'Sistemdeki toplam şarkı sayısı'
    },
    {
      name: 'Aktif Playlist',
      value: stats.activePlaylists,
      icon: ListMusic,
      description: 'Aktif kullanılan playlist sayısı'
    },
    {
      name: 'Depolama',
      value: stats.storageUsed,
      icon: Database,
      description: 'Kullanılan depolama alanı'
    }
  ];

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Müzik İstatistikleri</CardTitle>
      </CardHeader>
      <CardContent className="space-y-8">
        {/* Metrikler */}
        <div className="grid grid-cols-3 gap-4">
          {metrics.map((metric) => (
            <div
              key={metric.name}
              className="flex flex-col items-center justify-center p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
            >
              <div className="mb-2 p-2 rounded-lg bg-background/50 border border-border">
                <metric.icon className="w-5 h-5 text-primary" />
              </div>
              <div className="text-center">
                <p className="text-xl font-semibold mb-1">{metric.value}</p>
                <p className="text-sm text-muted-foreground">{metric.name}</p>
              </div>
            </div>
          ))}
        </div>

        {/* En Çok Çalınanlar */}
        <div>
          <h3 className="font-medium mb-4 flex items-center gap-2 text-muted-foreground">
            <PlayCircle className="w-4 h-4" />
            En Çok Çalınan Şarkılar
          </h3>
          <ScrollArea className="h-[240px] pr-4">
            <div className="space-y-3">
              {stats.topSongs.map((song, index) => (
                <div
                  key={song.id}
                  className="flex items-center gap-4 p-3 rounded-lg hover:bg-muted/30 transition-colors group"
                >
                  <div className="w-6 h-6 rounded-lg bg-primary/10 flex items-center justify-center text-sm font-medium text-primary">
                    {index + 1}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium truncate group-hover:text-primary transition-colors">
                      {song.title}
                    </p>
                    <p className="text-sm text-muted-foreground truncate">
                      {song.artist}
                    </p>
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {song.plays.toLocaleString()} çalma
                  </div>
                </div>
              ))}
            </div>
          </ScrollArea>
        </div>
      </CardContent>
    </Card>
  );
}
